import React, { useEffect, useState } from 'react'
import {
  Drawer,
  Button,
  Input,
  Dropdown,
  Menu,
  Icon,
  Modal,
  message,
  Switch,
  InputNumber
} from 'antd'
import './BadgesSetDrawer.scss'

import { api } from '../../../../../../../../services'
import Badge from '../../../../../../../Courses/Create/nestedComponents/CourseCreateMain/components/Badge'
import { connect } from 'react-redux'
import actions from '../../../../../../../../store/actions'
import { useTranslation } from 'react-i18next'

const BadgesSetDrawer = ({ visible, data, refreshData, onClose, upload }) => {
  const [state, setState] = useState({
    badges_enabled: false,
    badge_rules: [
      { badge_id: null, is_enabled: false, min_point: 0, max_point: 100 }
    ]
  })
  const [editingBadge, setEditingBadge] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [badgeOptions, setBadgeOptions] = useState([])
  const [selectedBadge, setSelectedBadge] = useState([])
  const [badgeLoading, setBadgeLoading] = useState(false)
  const [openBadgeModal, setOpenBadgeModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { t } = useTranslation()
  useEffect(() => {
    fetchOrgBadges()
  }, [])
  useEffect(() => {
    if (data) {
      setState(data)
      let badges = []
      if (data.badge_rules) {
        data.badge_rules.forEach(el => {
          if (el.badge) {
            badges.push(el.badge)
          }
        })
      }
      setBadgeOptions(pre => [...pre, ...badges])
    }
  }, [data])
  // Debounced search effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchTerm) {
        fetchOrgBadges(searchTerm)
      } else {
        fetchOrgBadges()
      }
    }, 300)

    return () => clearTimeout(timeoutId)
  }, [searchTerm])

  // Ensure drawer scrolls to top whenever it becomes visible
  useEffect(() => {
    if (!visible) return

    const scrollToTop = () => {
      try {
        const nodes = document.querySelectorAll(
          '.ant-drawer-body, .ant-drawer-wrapper-body'
        )
        nodes.forEach(node => {
          node.scrollTop = 0
        })
        const container = document.querySelector(
          '.badges-set-drawer__container'
        )
        if (container) container.scrollTop = 0
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      } catch (_) {
        // no-op
      }
    }

    // Try immediately, then a few times after render/animation
    const rafId = requestAnimationFrame(scrollToTop)
    const intervalId = setInterval(scrollToTop, 50)
    const stopId = setTimeout(() => clearInterval(intervalId), 600)

    return () => {
      cancelAnimationFrame(rafId)
      clearInterval(intervalId)
      clearTimeout(stopId)
    }
  }, [visible])

  const fetchOrgBadges = async search => {
    try {
      setBadgeLoading(true)
      const response = await api.library.getSopList({
        limit: 50,
        offset: 0,
        type: 'BADGE',
        sort: 'NEWEST',
        search
      })
      const badges = (response && response.data && response.data.rows) || []
      // Filter to only include items with format === 'BADGE'
      const filteredBadges = badges.filter(
        badge => badge.media_format === 'BADGE'
      )

      // Get badges from badge_rules to preserve them
      const badgesFromRules = state.badge_rules
        .filter(rule => rule.badge)
        .map(rule => rule.badge)

      // Combine search results with badges from rules, removing duplicates
      const allBadges = [...filteredBadges]
      badgesFromRules.forEach(badgeFromRule => {
        if (!allBadges.some(badge => badge.id === badgeFromRule.id)) {
          allBadges.push(badgeFromRule)
        }
      })

      setBadgeOptions(allBadges)
      setBadgeLoading(false)
    } catch (error) {
      setBadgeLoading(false)
      throw error
    }
  }

  const handleEditBadge = badge => {
    setEditingBadge(badge.id)
    setOpenBadgeModal(true)
  }

  const handleSelectBadge = badge => {
    // Check if badge is already selected in state
    const isAlreadySelected = state.badge_rules?.some(
      rule => rule.badge_id === badge.id
    )

    if (isAlreadySelected) {
      // Remove badge if already selected
      setState(prevState => ({
        ...prevState,
        badge_rules: prevState.badge_rules?.filter(
          rule => rule.badge_id !== badge.id
        )
      }))
    } else {
      // Add badge if not selected
      setState(prevState => ({
        ...prevState,
        badge_rules: [
          ...prevState.badge_rules,
          {
            badge_id: badge.id,
            badge: badge,
            is_enabled: true,
            min_point: 0,
            max_point: 100
          }
        ]
      }))
    }
  }

  const handleRemoveBadge = badgeId => {
    setState(prevState => ({
      ...prevState,
      badge_rules: prevState.badge_rules.filter(
        rule => rule.badge_id !== badgeId
      )
    }))
  }

  const handleBadgesEnabledToggle = checked => {
    setState(prevState => ({
      ...prevState,
      badges_enabled: checked
    }))
  }

  const handleBadgePointsChange = (badgeId, field, value) => {
    setState(prevState => ({
      ...prevState,
      badge_rules: prevState.badge_rules.map(rule =>
        rule.badge_id === badgeId ? { ...rule, [field]: value } : rule
      )
    }))
  }

  const menu = badge => (
    <Menu>
      <Menu.Item key="edit" onClick={() => handleEditBadge(badge)}>
        {t('v4:edit_badge')}
      </Menu.Item>
      <Menu.Item key="delete" onClick={() => handleRemoveBadge(badge.id)}>
        {t('labels:delete_badge')}
      </Menu.Item>
    </Menu>
  )
  const badgePresentationUpload = (body, imageType) => {
    setOpenBadgeModal(false)
    setBadgeLoading(true)
    upload(body)
      .then(res => {
        const { id, title, link } = res
        const newBadge = { id, title, link }
        const isAlreadySelected = selectedBadge.some(
          selected => selected.id === id
        )

        if (!isAlreadySelected) {
          setSelectedBadge([...selectedBadge, newBadge])
          handleSelectBadge(newBadge)
        }
        setBadgeLoading(false)
      })
      .catch(() => {
        setBadgeLoading(false)
        message.error('Error occured. Try Again !')
      })
  }
  const updateGlobalSettings = async () => {
    let data = {
      badges_enabled: state.badges_enabled,
      badge_rules: state.badge_rules
    }
    setIsLoading(true)
    try {
      await api.leaderboard.updateGlobalSettings(data)
      onClose()
      refreshData()
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <>
      <Drawer
        placement="right"
        width={700}
        closable={true}
        onClose={onClose}
        visible={visible}
        maskStyle={{ background: 'rgba(0,0,0,0.15)' }}
        bodyStyle={{ padding: 0 }}
        afterVisibleChange={v => {
          if (v) {
            setTimeout(() => {
              const drawerBody = document.querySelector('.ant-drawer-body')
              if (drawerBody) {
                drawerBody.scrollTop = 0
              }
              const container = document.querySelector(
                '.badges-set-drawer__container'
              )
              if (container) {
                container.scrollTop = 0
              }
            }, 50)
          }
        }}
      >
        <div className="badges-set-drawer">
          <div className="badges-set-drawer__container">
            <div className="badges-set-drawer__header">
              <div className="badges-set-drawer__subtitle">
                {t('v4:badgess_set')}
              </div>
              <div className="badges-set-drawer__desc">
                {t('v4:choose_the_default_visual_style_for_badge')}
              </div>
            </div>

            {/* Badge Selection Section */}
            <div className="badges-set-drawer__selection-section">
              <div className="badges-set-drawer__selection-header">
                <span className="badges-set-drawer__selection-title">
                  {t('v4:enable_badges')}
                </span>
                <Switch
                  checked={state.badges_enabled}
                  onChange={handleBadgesEnabledToggle}
                  size="default"
                />
              </div>

              {state.badges_enabled && (
                <div className="badges-set-drawer__selection-content">
                  <Input.Search
                    className="badges-set-drawer__selection-search"
                    placeholder="Search badges to add..."
                    style={{ width: '100%', marginBottom: 16 }}
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    allowClear
                  />

                  <div className="badges-set-drawer__selection-grid">
                    {badgeOptions.map(badge => {
                      const isSelected = state.badge_rules?.some(
                        rule => rule.badge_id === badge.id
                      )
                      return (
                        <div
                          key={badge.id}
                          className={`badges-set-drawer__selection-badge-card ${
                            isSelected ? 'selected' : ''
                          }`}
                          onClick={() => handleSelectBadge(badge)}
                          title={badge.title}
                        >
                          <div className="badges-set-drawer__selection-badge-img">
                            <img
                              src={badge.link}
                              alt={badge.title}
                              className="badges-set-drawer__selection-badge-img-img"
                            />
                            {isSelected && (
                              <div className="badges-set-drawer__selection-badge-overlay">
                                <Icon
                                  type="check"
                                  style={{ color: '#fff', fontSize: 14 }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="badges-set-drawer__selection-badge-title">
                            {badge.title}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>

            {state.badges_enabled && (
              <div className="badges-set-drawer__preview-section">
                <div className="badges-set-drawer__preview-header-row">
                  <div className="badges-set-drawer__preview-header-row-left">
                    <span className="badges-set-drawer__preview-title">
                      {t('v2:badges')} ({state.badge_rules?.length || 0})
                    </span>
                  </div>
                  <Button
                    type="primary"
                    className="badges-set-drawer__add-btn"
                    loading={badgeLoading}
                    onClick={() => {
                      setEditingBadge(null)
                      setOpenBadgeModal(true)
                    }}
                  >
                    + {t('v4:add_badge')}
                  </Button>
                </div>
                <div className="badges-set-drawer__badges-grid">
                  {state.badge_rules?.map(rule => {
                    const badge =
                      rule.badge ||
                      badgeOptions.find(b => b.id === rule.badge_id)
                    if (!badge) return null

                    return (
                      <div
                        className="badges-set-drawer__badge-card"
                        key={rule.badge_id}
                      >
                        <div className="badges-set-drawer__badge-header">
                          <div className="badges-set-drawer__badge-title">
                            {badge.title}
                          </div>
                          <div className="badges-set-drawer__badge-actions">
                            <Dropdown
                              overlay={menu(badge)}
                              trigger={['click']}
                              placement="bottomRight"
                            >
                              <Icon
                                type="ellipsis"
                                className="badges-set-drawer__badge-menu-btn"
                              />
                            </Dropdown>
                          </div>
                        </div>
                        <div className="badges-set-drawer__badge-img">
                          <img
                            src={badge.link}
                            alt={badge.title}
                            className="badges-set-drawer__badge-img-img"
                          />
                        </div>
                        <div className="badges-set-drawer__badge-info">
                          <div className="badges-set-drawer__badge-title badges-set-drawer__badge-title--centered">
                            {badge.title}
                          </div>
                          <div className="badges-set-drawer__badge-desc badges-set-drawer__badge-desc--centered">
                            {badge.description}
                          </div>
                          <div className="badges-set-drawer__badge-points-row">
                            <div className="badges-set-drawer__badge-point-group">
                              <label className="badges-set-drawer__badge-point-label">
                                {t('v4:min')}
                              </label>
                              <InputNumber
                                min={0}
                                max={rule.max_point}
                                value={rule.min_point}
                                onChange={value =>
                                  handleBadgePointsChange(
                                    rule.badge_id,
                                    'min_point',
                                    value
                                  )
                                }
                                className="badges-set-drawer__badge-point-input"
                                size="small"
                              />
                            </div>
                            <div className="badges-set-drawer__badge-point-group">
                              <label className="badges-set-drawer__badge-point-label">
                                {t('v4:max')}
                              </label>
                              <InputNumber
                                min={rule.min_point}
                                value={rule.max_point}
                                onChange={value =>
                                  handleBadgePointsChange(
                                    rule.badge_id,
                                    'max_point',
                                    value
                                  )
                                }
                                className="badges-set-drawer__badge-point-input"
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
            <div className="badges-set-drawer__footer">
              <Button
                className="badges-set-drawer__discard"
                onClick={onClose}
                disabled={badgeLoading || isLoading}
              >
                {t('v4:discard')}
              </Button>
              <Button
                type="primary"
                className="badges-set-drawer__save"
                loading={isLoading}
                disabled={badgeLoading}
                onClick={updateGlobalSettings}
              >
                {t('buttons:save')}
              </Button>
            </div>
          </div>
        </div>
      </Drawer>

      {/* <BadgeEditor
        visible={showBadgeEditDrawer}
        onClose={handleBadgeEditorClose}
        badge={editingBadge}
        onSave={handleBadgeSave}
      /> */}
      {openBadgeModal && (
        <Modal
          style={{ top: 20 }}
          bodyStyle={{ height: 'auto', maxHeight: '90vh', overflowY: 'auto' }}
          visible={openBadgeModal}
          onCancel={() => setOpenBadgeModal(false)}
          footer={null}
          width="1229px"
          afterVisibleChange={visible => {
            if (visible) {
              // Scroll to top when modal becomes visible
              setTimeout(() => {
                const modalBody = document.querySelector('.ant-modal-body')
                if (modalBody) {
                  modalBody.scrollTop = 0
                }

                const badgeModalWrap = document.querySelector(
                  '.badge-creator-modal-wrap'
                )
                if (badgeModalWrap) {
                  badgeModalWrap.scrollTop = 0
                }
              }, 100)
            }
          }}
        >
          <Badge
            courseBadgeId={editingBadge}
            onUploadImage={body => {
              badgePresentationUpload(body, 'Badge')
            }}
          />
        </Modal>
      )}
    </>
  )
}

const mapDispatchToProps = dispatch => ({
  upload: (file, opts) => dispatch(actions.library.upload(file, opts))
})

export default connect(null, mapDispatchToProps)(BadgesSetDrawer)
